import React from 'react'
import { OpenBetsProvider as SportsbookOpenBetsProvider, useOpenBets } from '@repo/sportsbook-core'
import { useGroowthbookLocaleFeature } from '../hooks/useGrowthbook'

export const OpenBetsProvider = ({ children }) => {
  const isSportsEnabled = useGroowthbookLocaleFeature('fe_igp_sports_enabled')

  return (
    <SportsbookOpenBetsProvider
      isSportsEnabled={isSportsEnabled}
    >
      {children}
    </SportsbookOpenBetsProvider>
  )
}

export { useOpenBets }
